import { render, staticRenderFns } from "./ProjectSelect.vue?vue&type=template&id=32752ec6&"
import script from "./ProjectSelect.ts?vue&type=script&lang=ts&"
export * from "./ProjectSelect.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports